<template>
  <div :class="{ 'flex items-center': item.suffixIcon, hidden: !item.show }">
    <router-link
      :to="item.href"
      custom
      v-slot="{ href, navigate, isExactActive }"
    >
      <a
        :href="href"
        :class="[
          isExactActive
            ? 'bg-white bg-opacity-[0.08] text-white hover:text-white font-medium'
            : secondary
            ? 'text-white text-opacity-50 hover:text-opacity-100 hover:text-white hover:bg-white hover:bg-opacity-[0.08] font-normal'
            : 'text-white hover:text-white hover:bg-white hover:bg-opacity-[0.08] font-normal',
          'group flex items-center px-2.5 py-2.5 text-base rounded-lg transition-all flex-1 hover:no-underline no-underline focus:no-underline active:no-underline',
        ]"
        :aria-current="isExactActive ? 'page' : undefined"
        @click="
          (event) =>
            refreshOnNavigate ? goTo({ href, event }) : navigate(event)
        "
      >
        <component
          :is="item.icon"
          :class="[
            isExactActive
              ? 'text-primary'
              : 'text-white text-opacity-40 group-hover:text-primary-500',
            'mr-3 flex-shrink-0 h-6 w-6 transition-all',
          ]"
          aria-hidden="true"
        />
        {{ item.name }}
        <span
          v-if="item.badge"
          class="ml-auto rounded-full bg-[#EB5757] ring-[3px] ring-red-500/30 relative w-5 h-5 inline-flex items-center justify-center text-[11px] font-bold"
        >
          <span class="">
            {{ item.badge.text }}
          </span>
        </span>
      </a>
    </router-link>
    <div
      v-if="item.suffixIcon && item.suffixOnClick"
      class="grid ml-0.5 place-items-center"
    >
      <button
        @click.prevent="item.suffixOnClick"
        class="px-3 text-center group rounded-lg py-2.5 hover:bg-white hover:bg-opacity-[0.08] transition-all"
        :title="item.suffixTitle"
        v-tooltip:right.tooltip="item.suffixTitle"
      >
        <component
          :is="item.suffixIcon"
          class="flex-shrink-0 w-6 h-6 mx-auto text-white transition-all text-opacity-40 group-hover:text-primary-500"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>
<script>
import { getNewAppUrl } from '@/utils/urls'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    secondary: {
      type: Boolean,
    },
    linkToNewApp: {
      type: Boolean,
      default: false,
    },
    refreshOnNavigate: Boolean,
  },
  setup(props) {
    const goTo = ({ event, href }) => {
      event.preventDefault()
      event.stopPropagation()
      const newHref = props.linkToNewApp ? getNewAppUrl(href) : href
      location.href = getNewAppUrl(newHref)
    }
    return { goTo }
  },
}
</script>

<style scoped lang="scss">
.badge-inner {
  // padding: 5px 8px;
  font-size: 12px;
  top: 4px;
}
</style>
